import React, { memo, useEffect, useRef, useState } from 'react';
import { Link, matchRoutes, useLocation } from 'react-router-dom';

import logo from 'assets/images/dexatel-logo.svg';
import logoSmall from 'assets/images/dexatel-logo-small.svg';
import { DxButton, DxIcon } from 'components/common';
import 'assets/scss/leftNavigation.scss';
import { useLocalization } from 'hooks';
import routes from 'constants/routes';
import DxMenu from './Menu/Menu';
import { privateRoutes } from 'routes/PrivateRoutes';

const LeftNavigation: React.FC = () => {
    const { t } = useLocalization();
    const location = useLocation();
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef<HTMLDivElement>(null);
    const matches = matchRoutes(privateRoutes, location) || [];
    const defaultOpenKeys = matches.filter((item) => item.pathname !== '/').map((item) => item.pathname);

    useEffect(() => {
        const handleClick = (event: MouseEvent) => {
            const target = event.target as HTMLElement;

            const isInsideAntSubmenu = target.closest('.ant-menu-submenu');
            const isInsideBurgerIcon = target.closest('.burger-icon');

            if (!isInsideAntSubmenu && !isInsideBurgerIcon) {
                setIsOpen(false);
            }
        };

        document.addEventListener('click', handleClick);
        return () => document.removeEventListener('click', handleClick);
    }, []);

    useEffect(() => {
        setIsOpen(false);
    }, [location.pathname]);

    return (
        <div className={`left-navigation-outer position-relative h-100 ${isOpen ? 'open' : ''}`}>
            <aside className={`left-navigation ${isOpen ? 'open' : ''}`}>
                <div onClick={() => setIsOpen(!isOpen)} className="burger-icon position-absolute d-xl-none d-block">
                    <DxIcon size="md" type="hamburger" />
                </div>
                <div ref={dropdownRef} className="logo-outer d-flex align-items-center justify-content-center mx-auto">
                    <Link className="d-block" to={routes.DASHBOARD}>
                        <img className="d-xl-block d-none" src={logo} alt="Dexatel" width={146} height={26} />
                        <img className="d-xl-none d-block" src={logoSmall} alt="Dexatel" width={34} height={34} />
                    </Link>
                </div>
                <div className="left-navigation-inner d-flex flex-column">
                    <div className="left-navigation-content">
                        <Link to={routes.TRY_IT_NOW} className="try-btn d-xl-none d-block">
                            <DxIcon size="md" type="message_plus_alt" />
                        </Link>
                        <Link to={routes.TRY_IT_NOW} className="d-xl-block d-none">
                            <DxButton radius="sharped" appearance="default">
                                {t('TRY_IT_NOW')}
                            </DxButton>
                        </Link>
                    </div>
                    <DxMenu defaultOpenKeys={defaultOpenKeys} setIsOpen={setIsOpen} />
                </div>
            </aside>
        </div>
    );
};

export default memo(LeftNavigation);
